/* F-62: kleefgedrag van de kop zoals de bron. De kop scrolt eerst met de pagina mee en staat pas vast bovenaan nadat de bezoeker voorbij de kop is
   gescrold (computer: na 270 px, telefoon: na 230 px). Het script zet alleen de klasse bri-kop-vast op <html>; de maten staan in
   snippets/bri-kop-voet-stijl.liquid. Op de computer scrolt in Horizon de houder .page-wrapper, op de telefoon het document. */
(function () {
  'use strict';

  var wortel = document.documentElement;
  var houder = document.querySelector('.page-wrapper');
  var wacht = false;

  function hoogte() {
    var y = window.scrollY || 0;
    if (houder && houder.scrollHeight > houder.clientHeight + 1) y = Math.max(y, houder.scrollTop);
    return y;
  }

  function bijwerken() {
    wacht = false;
    var drempel = window.matchMedia('(min-width: 750px)').matches ? 270 : 230;
    wortel.classList.toggle('bri-kop-vast', hoogte() > drempel);
  }

  function opScroll() {
    if (wacht) return;
    wacht = true;
    window.requestAnimationFrame(bijwerken);
  }

  window.addEventListener('scroll', opScroll, { passive: true });
  if (houder) houder.addEventListener('scroll', opScroll, { passive: true });
  window.addEventListener('resize', opScroll);
  bijwerken();
})();
